import { ConnectionSelect } from '@app/modules/social-export/components/ConnectionSelect';
import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import { FormSectionV2 } from '@app/core/components/FormSectionV2';
import { connectionsManageMessages as messages } from '@app/modules/social-export/screens/manage/connections-manage-messages';
import { SocialExportGetStationConnectionStateDto } from '@mi-front/api-v2';
import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

type PublishConnectionSelectorProps = {
  connections: SocialExportGetStationConnectionStateDto[];
  selectedConnectionId: string | null;
  onSelectedConnectionChange: (id: string | null) => void;
  platform: SocialPlatform;
  children?: ReactNode;
};

/**
 * Form section with a select to pick the publication account.
 */
export function PublishConnectionSelector({
  connections,
  selectedConnectionId,
  onSelectedConnectionChange,
  platform,
  children,
}: PublishConnectionSelectorProps) {
  return (
    <FormSectionV2 title={<FormattedMessage {...messages.selectConnectionForPublish} />}>
      <ConnectionSelect
        id="publish-connection-select"
        connections={connections}
        value={selectedConnectionId}
        onChange={onSelectedConnectionChange}
        platform={platform}
        readOnly={connections.length <= 1}
        sx={{ maxWidth: 360 }}
      />
      {children}
    </FormSectionV2>
  );
}
